import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddNumber from './AddNumber';
import { addNumberModalCancel } from '../../actions/Numbers';
import NumberModalEpikBox from './NumberModalEpikBox';
import AddNumberBulk from './AddNumberBulk';
import { getGateways } from '../../actions/Provisioning';
import Toggle from '../Toggle';
import { numberCarrierOptions } from '../../utils/constants';

const AddNumberModal = ({
  isOpen,
  onConfirm,
  onCancel,
  company,
  type,
  addNumberModalCancel,
  getGateways,
  onBulkConfirm,
}) => {
  const [nestedModal, setNestedModal] = useState(false);
  const [bulkEnable, setBulkEnable] = useState(false);
  const carrier = useSelector(state => state.UIState.numbers.addNumber.carrier);
  const [formData, setFormData] = useState({
    number: '',
    routeInfo: '',
    company: '',
    tdmRoute: {}
  });

  const toggle = () => {
    setNestedModal(!nestedModal);
    addNumberModalCancel();
  };

  const onChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleBulk = () => {
    let splittedNumbers = formData.number.split(/[\n,]/);
    let finalObj = [];
    splittedNumbers.forEach((item, idx) => {
      finalObj.push({
        number: item.trim().replace(/ /g, ''),
        routeInfo: formData.routeInfo,
        company: formData.company,
        trunk: formData.trunk,
        tdmRoute: formData.tdmRoute?.value,
        carrier: carrier?.value || "inteliquent"
      });

      if (splittedNumbers.length - 1 === idx) {
        onBulkConfirm(finalObj);
      }
    });
  };

  return (
    <Modal size="lg" style={{ maxWidth: '900px' }} isOpen={isOpen}>
      <ModalHeader className="number-modal">
        Add new Number
        <div className="bulk-toggle">
          Bulk
          <Toggle
            value={bulkEnable}
            onToggle={e => {
              getGateways(localStorage.getItem('jwtToken') || null);
              setBulkEnable(!bulkEnable);
            }}
          />
        </div>
      </ModalHeader>
      <ModalBody>
        {bulkEnable ? <AddNumberBulk onChange={onChange} /> : <AddNumber />}
        {!bulkEnable &&
          company &&
          (type !== 'vmail' &&
            type !== 'dialout' &&
            type !== 'unassigned' &&
            type !== 'forward') && (
            <>
              <Button color="primary" onClick={toggle}>
                Generate uri for epikbox
              </Button>
              <Modal isOpen={nestedModal} toggle={toggle}>
                <ModalBody>
                  <NumberModalEpikBox />
                </ModalBody>
                <ModalFooter>
                  {/* <Button color="primary" onClick={toggle}>Save</Button>{' '} */}
                  <Button color="secondary" onClick={toggle}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            </>
          )}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={e => {
            if (bulkEnable) {
              handleBulk();
            } else {
              onConfirm(e);
            }
          }}
        >
          Send
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  company: state.UIState.numbers.addNumber.company,
  type: state.UIState.numbers.addNumber.type,
});

const mapDispatchToProps = dispatch => ({
  addNumberModalCancel: () => dispatch(addNumberModalCancel()),
  getGateways: token => dispatch(getGateways(token)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNumberModal);
